import { Component, OnInit, Inject, PLATFORM_ID } from '@angular/core';
import { ProductCategoryService } from '../_services/product-category.service';
import { AppConstants } from '../_constants/constants';
import { isPlatformBrowser } from '@angular/common';
import { AdBannerService } from '../_services/ad-banner.service';
import { AdBanner } from '../_models/ad-banner';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-new-slider',
    templateUrl: './new-slider.component.html',
    styleUrls: ['./new-slider.component.css'],
    standalone: false
})
export class NewSliderComponent implements OnInit {
    category_list: any[] = [];
    currentLanguage: string | null = null;
    loadingCategories = true;
    slides: { img: string; url: string; show_btn: boolean }[] = [];
    sliderLeftBanners: AdBanner[] = [];

    slideConfig = {
        autoplay: true,
        dots: true,
        arrows: true,
        slidesToShow: 1,
        slidesToScroll: 1,
    };

    slickInit(e: any) {}
    breakpoint(e: any) {}
    afterChange(e: any) {}
    beforeChange(e: any) {}

    constructor(
        private productCatService: ProductCategoryService,
        private adBannerService: AdBannerService,
        @Inject(PLATFORM_ID) private platformId: Object
    ) {}

    ngOnInit() {
        if (isPlatformBrowser(this.platformId)) {
            this.currentLanguage = localStorage.getItem(AppConstants.CURRENT_LANG_STORE_KEY);
        }
        this.productCatService.get_category_list()
            .subscribe((data) => {
                this.category_list = data;
                this.loadingCategories = false;
            });

        this.adBannerService.loadByGroup('SLIDER').subscribe(banners => {
            this.slides = banners.map(b => ({
                img: environment.image_cdn_url + '/' + b.imagePath,
                url: b.url || '/',
                show_btn: !!b.url
            }));
        });

        this.adBannerService.loadByGroup('SLIDER_LEFT').subscribe(banners => {
            this.sliderLeftBanners = banners;
        });
    }

    bannerImageUrl(banner: AdBanner): string {
        return environment.image_cdn_url + '/' + banner.imagePath;
    }
}
